import React, { useMemo } from 'react';

import EmptyData from '../../../components/UI/EmptyData';
import { celebrationsWithDaysLeft } from '../utils/celebrationWindow';
import CelebrationSnapSlider from './CelebrationSnapSlider';

const WorkAnniversary = ({ workAnniversaryList, embedded }) => {
  const withDays = useMemo(
    () => celebrationsWithDaysLeft(workAnniversaryList, 'dateOfJoining'),
    [workAnniversaryList]
  );

  const listItems = useMemo(
    () => withDays.map((x) => ({ ...x.item, daysLeft: x.daysLeft })),
    [withDays]
  );

  if (embedded && withDays.length === 0) {
    return (
      <div className="">
        <EmptyData />
      </div>
    );
  }

  const listSection = (
    <div
      className={`${embedded ? 'px-0' : 'card-body px-0'} dashboard-celebrations-scroll dashboard-celebrations-scroll--compact`}
    >
      <div className="px-2 px-sm-3">
        <CelebrationSnapSlider variant="anniversary" items={listItems.slice(0, 6)} />
      </div>
    </div>
  );

  if (embedded) {
    return listSection;
  }

  return (
    <div className="card">
      <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
        <h6 className="mb-0 fw-bold">Anniversaries</h6>
      </div>
      {withDays?.length > 0 ? (
        listSection
      ) : (
        <div className="card-body py-4">
          <EmptyData />
        </div>
      )}
    </div>
  );
};

export default WorkAnniversary;
